import { render, staticRenderFns } from "./TaxCalculator.vue?vue&type=template&id=4654e79a&scoped=true"
import script from "./TaxCalculator.vue?vue&type=script&lang=js"
export * from "./TaxCalculator.vue?vue&type=script&lang=js"
import style0 from "./TaxCalculator.vue?vue&type=style&index=0&id=4654e79a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4654e79a",
  null
  
)

export default component.exports